// Parses a date-only value (e.g. "2026-07-20", an ISO datetime like
// "2026-07-20T00:00:00.000000Z", or a space-separated datetime like
// "2026-07-20 00:00:00") as a LOCAL calendar date, ignoring any UTC
// time/offset component. `new Date(isoString)` parses date-only ISO
// strings as UTC midnight, which shifts backward one day when displayed
// in negative-offset timezones (e.g. Chile). fecha_entrega is a calendar
// date, not a real point in time, so it must never go through UTC parsing.
export function parseFechaLocal(fecha) {
  if (!fecha) return null;
  if (fecha instanceof Date) return fecha;
  const str = String(fecha).replace('T', ' ').split('.')[0];
  const datePart = str.split(' ')[0];
  const [y, m, d] = datePart.split('-').map(Number);
  if (!y || !m || !d) return null;
  return new Date(y, m - 1, d);
}

// Same as parseFechaLocal but also applies a "HH:MM" time-of-day, for
// sorting/display that needs to respect hora_entrega too.
export function parseFechaHoraLocal(fecha, hora) {
  const parsed = parseFechaLocal(fecha);
  if (!parsed) return new Date(NaN);
  const [h, min] = String(hora || "00:00").split(":").map(Number);
  parsed.setHours(h || 0, min || 0, 0, 0);
  return parsed;
}

// porcion is legitimately null for fixed-price order types (precio_fijo,
// precio_por_unidad, paquete) — this must never be rendered as literal
// "null porciones".
export function formatPorcionesOCantidad(pedido) {
  if (pedido.porcion != null) {
    return `${pedido.porcion} porciones`;
  }
  const cantidad = pedido.cantidad ?? 1;
  return `${cantidad} unidad${cantidad === 1 ? "" : "es"}`;
}
